.ju0xx40 {
  z-index: -1;
  grid-area: main;
  width: 100%;
  height: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  container-type: inline-size;
  padding-bottom: calc(54px + env(safe-area-inset-bottom));
}
.ju0xx40:has(> ._1u10klk0), [data-sidebar-hidden] > .ju0xx40 {
  padding-bottom: 0;
}
@media screen and (min-width: 768px) {
  .ju0xx40 {
    padding-bottom: 0;
  }
}